import React, { useState, useEffect, useRef } from "react";
import { addCandidateRelationship } from './api/Calls';
import { getSingleCondidate, getNewFamilyList } from '../../../Redux/Actions/newJoinerAction';
import { useDispatch, useSelector } from "react-redux";
import { updateCandidateRelationship } from '../../HR/onboarding/api/Calls'
import moment from 'moment';

const AddFamilyModel = ({ email, edit, setSelected }) => {

  const dispatch = useDispatch();
  const { onecondidate } = useSelector((state) => state.NewJoinerReducer);
  const cancelRef = useRef(null);
  const [name, setname] = useState('');
  const [relationship, setrelationship] = useState('');
  const [occupation, setoccupation] = useState('');
  const [dob, setdob] = useState('');
  const [values, setValues] = useState('');
  const [age, setAge] = useState('')

  const handleChange = (e) => {
    const ageCalculate = e.target.value;

    if (ageCalculate) {
      setdob(ageCalculate)
      var today = new Date();
      var birthDate = new Date(`${moment(ageCalculate).format('YYYY-MM-DD')}`);
      var age_now = today.getFullYear() - birthDate.getFullYear();
      var m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age_now--;
      }
      setAge(age_now)

    } else {
      setAge('');
    }
  };
  useEffect(() => {
    if (edit) { setname(edit.name) }else{ setname('')}
    if (edit) { setrelationship(edit.relationship) }else{ setrelationship('')}
    if (edit) { setoccupation(edit.occupation) }else{setoccupation('')}
    if (edit) { setdob(edit.dob) }else{setdob('')}
    if (edit) { setAge(edit.age) }else{setAge('')}
    dispatch(getSingleCondidate(email))
   
    

  }, [email, edit])
  const handleCancel = () => {
    setSelected(null);
    setAge('');
    setname('');
    setrelationship('');
    setoccupation('');
    setdob('');
    //setValues(initialValues);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (name === '' || dob === '' || relationship === '' || occupation === '' || age === '') {
      return alert('All field is required !');
    } else {
      const updatedData = {
        user_id: onecondidate?.condidateID,
        age: age,
        name: name,
        relationship: relationship,
        dob: dob,
        occupation: occupation,
      }
      addCandidateRelationship(updatedData, onecondidate?.condidateID).then((res) => {
        if (res.status) {
          setSelected(null);
          setAge('');
          setname('');
          setrelationship('');
          setoccupation('');
          setdob('');
          cancelRef.current.click();
          dispatch(getNewFamilyList(onecondidate?.condidateID));
          return alert(res.msg)
        } else {
          return alert(res.msg)
        }
      })
    }
  }
  const handleUpdateInfo = (e) => {

    e.preventDefault();
    if (name === '' || age === '' || relationship === '' || occupation === '' || dob === '') {
      return alert('All field is required !');
    } else {
      const updatedData = {
        age: age,
        name: name,
        relationship: relationship,
        dob: dob,
        occupation: occupation,
        updated_by: onecondidate?.condidateID
      }
      updateCandidateRelationship(updatedData, edit.id).then((res) => {
        if (res.status) {
          setSelected(null);
          setAge('');
          setrelationship('');
          setoccupation('');
          setdob('');
          cancelRef.current.click();
          dispatch(getNewFamilyList(onecondidate?.condidateID));
          return alert(res.msg)
        } else {
          return alert(res.msg)
        }
      })
    }
  }

  return (
    <>
      <div className="modal fade" id="addfamilydetail" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-body">
              <button type="button" className="float-end btn_close" data-bs-dismiss="modal" aria-label="Close">
                <i className="icon icon-cross" ref={cancelRef} onClick={handleCancel} />
              </button>
              <div className="dash_white_box_ttl text-center" id="exampleModalLabel">{edit === null ? 'Add' : 'Edit'} Family Detail</div>

              <div className="mb-2">
                <label className="col-form-label">Name <sup className="error_mgs">*</sup></label>
                <input type="text" className="form-control" id="name" onChange={e => { setname(e.target.value) }} name="name" value={name} />
              </div>
              <div className="mb-2">
                <label className="col-form-label">Relationship <sup className="error_mgs">*</sup></label>
                <input type="text" className="form-control" id="relationship" onChange={e => { setrelationship(e.target.value) }} name="relationship" value={relationship} />
              </div>
              <div className="mb-2 row">
                <div className="col-md-6"><label className="col-form-label">Date of Birth <sup className="error_mgs">*</sup></label>
                  <input type="date" className="form-control" id="dob" onChange={handleChange} name="dob" value={moment(dob).format('yyyy-MM-DD')} />

                </div>
                <div className="col-md-6">
                  <label className="col-form-label">Age </label>
                  <input type="text" className="form-control" id="age" readOnly onChange={e => { setAge(e.target.value) }} name="age" value={age} />
                </div>
              </div>
              <div className="mb-4">
                <label className="col-form-label">Occupation <sup className="error_mgs">*</sup></label>
                <input type="text" className="form-control" id="occupation" onChange={e => { setoccupation(e.target.value) }} name="occupation" value={occupation} />
              </div>
              <div className="modalfooter">
                <button type="button" className="btn_6 float-end ml10" data-bs-dismiss="modal" ref={cancelRef} onClick={handleCancel}>Cancel</button>
                <button type="button" onClick={edit === null ? handleSubmit : handleUpdateInfo} className="btn_5 float-end ">{edit === null ? 'Add' : 'Update'}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default AddFamilyModel;